import React, { useEffect } from "react";
import DropDownLogicalUnits from "./DropDownLogicalUnits";
import { Label, Stack } from "@fluentui/react";
import AdvSearchObjectModel from "../checkinDocuments/AdvSearchObjectModel";
import { useCommonControlsStyle } from "../../theme/styles/CommonControlsStyle";
import { useLogin } from "../../redux/hooks/useLogin";
import { useMetadata } from "../../redux/hooks/useMetadata";
import { useCheckin } from "../../redux/hooks/useCheckin";
import {
  DATA_LOAD_STATUS,
  REFRESH_TOKEN_ACTION,
  RESPONSE_TYPE,
} from "../../redux/constants/metaData";

const AdvSearchObjectConnectionTab = ({ embedded = false }) => {
  const styleTheme = useCommonControlsStyle();
  const { teamsContext } = useLogin();
  const { logicalUnit, objectConnectionDataLoad } = useMetadata();
  const { onObjectConnectionsLoad } = useCheckin();

  useEffect(() => {
    if (!teamsContext) {
      return;
    }

    const hasUnits = Array.isArray(logicalUnit) && logicalUnit.length > 0;
    if (hasUnits) {
      return;
    }

    const isLoading =
      objectConnectionDataLoad === DATA_LOAD_STATUS.onStart ||
      objectConnectionDataLoad === DATA_LOAD_STATUS.onLoad;
    if (isLoading) {
      return;
    }

    if (
      objectConnectionDataLoad !== DATA_LOAD_STATUS.onStart &&
      objectConnectionDataLoad !== DATA_LOAD_STATUS.error
    ) {
      return;
    }

    onObjectConnectionsLoad(teamsContext, {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.logicalUnitsLoad,
      refreshResponse: RESPONSE_TYPE.none,
    });
  }, [
    teamsContext,
    logicalUnit,
    objectConnectionDataLoad,
    onObjectConnectionsLoad,
  ]);

  if (embedded) {
    return (
      <div style={{ marginTop: 4 }}>
        <Stack tokens={{ childrenGap: 12 }} styles={{ root: { width: "100%" } }}>
          <Stack.Item>
            <Label style={styleTheme.LabelStyle}>Object Type</Label>
          </Stack.Item>
          <Stack.Item>
            <DropDownLogicalUnits />
          </Stack.Item>
          <Stack.Item align="end">
            <AdvSearchObjectModel />
          </Stack.Item>
        </Stack>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 10 }}>
      <Stack
        tokens={{ childrenGap: 20 }}
        styles={{ root: { marginLeft: "auto", marginRight: "auto", width: "70vw" } }}
      >
        <Stack horizontal disableShrink tokens={{ childrenGap: 10 }}>
          <Stack.Item
            align="center"
            styles={{ root: { padding: 5, width: 100 } }}
            style={styleTheme.LabelStyle}
          >
            Object Type
          </Stack.Item>

          <Stack.Item grow align="stretch" styles={{ root: { padding: 5, minWidth: 200 } }}>
            {<DropDownLogicalUnits />}
          </Stack.Item>

          <Stack.Item align="center" styles={{ root: { padding: 5, width: 169 } }}>
            {<AdvSearchObjectModel />}
          </Stack.Item>
        </Stack>
      </Stack>
    </div>
  );
};

export default AdvSearchObjectConnectionTab;
